import { TOUR_TRANSLATIONS } from "../translations"

export const getLbbDetailsSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="lbb-details-filters"]',
            title: t.lbbDetailsFilters.title,
            content: t.lbbDetailsFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="lbb-details-table"]',
            title: t.lbbDetailsTable.title,
            content: t.lbbDetailsTable.content,
        },
        {
            target: '[data-tour="lbb-details-create-report"]',
            title: t.lbbDetailsCreateReport.title,
            content: t.lbbDetailsCreateReport.content,
        },
        {
            target: '.MuiDialog-paper, .MuiDrawer-paper',
            title: t.lbbDetailsEvolution.title,
            content: t.lbbDetailsEvolution.content,
            placement: 'center',
            disableScrolling: true,
            data: { triggerClick: 'lbb-details-table', closeOnLeave: true },
        },
    ]
}
